import { DragNDrop } from '@/src/components';
import { Icon } from '@/src/tools/icon';
import { Divider } from 'antd';
import { Input } from '@/src/components/Antd';

import { get, set } from 'lodash';
import React from 'react';
import Button from 'src/components/CloneButton';
import LeftGreenBlock from 'src/components/DragContainers/LeftGreenBlock';
import { SectionContainer as Section } from 'src/components/Layouts';
import {
  Field,
  Form, //antdErrorDisplayAdaptor
} from 'src/components/RcForm';
import { validateLayerType } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import GeneralCollapseHeader from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseHeader';
import { useI18n } from 'src/hooks/useRouterChange';
import { layers, name } from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const Layers = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    disabled,
    isPrimary = true,
    onClick,
    onAdd,
    onReorder,
    onDelete,
    extra,
  } = props;

  const dotsFunctionGenerator = (disabled, onDelete) => {
    if (disabled) {
      return [];
    } else {
      return [
        {
          key: 'Delete',
          body: getI18n('general.delete'),
          isDangerous: true,
          //displayWarningModal: true,
          onClick: onDelete,
          //modalOnOk: () => onDelete(),
          // modalTitle: 'Delete Layer',
          // modalContent: 'Are you sure to delete the layer ?',
        },
      ];
    }
  };

  const titleContentGenerator = (value, onChange) => {
    return (
      <LeftGreenBlock disabled={disabled}>
        <div className={css.titleContainer}>
          {get(value, 'visible') ? (
            <Icon
              type='iconvisible'
              className={`${css.visible} ${disabled ? css.disabledIcon : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
            />
          ) : (
            <Icon
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
              type='iconinvisible'
              className={css.inVisible}
            />
          )}
          <LayerName
            value={get(value, 'name')}
            onChange={onChange}
            disabled={disabled}
          />

          {/* {name || `${getI18n('salesChannelContent.index.layer')} ${index + 1}`} */}
        </div>
      </LeftGreenBlock>
    );
  };

  return (
    <Field name={layers}>
      {(props, meta) => {
        const { value, onChange } = props;
        const handleOnAdd = () => {
          if (onAdd) {
            onAdd(value, onChange);
          }
        };

        const handleOnOrderOnChange = (index, target) => {
          const from = index;
          const to = target;
          onReorder(value, onChange, from, to);
        };

        const handleOnDelete = (index) => {
          onDelete(value, onChange, index);
        };

        const handleOnNameChange = (n, index) => {
          const v = set(value, `${index}.${name}`, n);
          onChange(v);
        };

        const renderChild = (layer, provided, index) => {
          //const { visible } = layer || {};
          return (
            <LayerHeader
              onClick={() => {
                if (onClick) {
                  onClick(layer);
                }
              }}
              className={css.titleWrapper}
              containerProps={provided.dragHandleProps || {}}
              hasDots={isPrimary}
              dotsFunction={dotsFunctionGenerator(disabled, () => {
                handleOnDelete(index);
              })}
              content={titleContentGenerator(layer, (name) => {
                handleOnNameChange(name, index);
              })}
              disabled={disabled}
              extra={{ ...(extra || {}), index, layer }}
            />
          );
        };

        return (
          <React.Fragment>
            <Section className={css.section}>
              <Divider className={css.divider} />
              <div className={css.title}>
                {getI18n('salesChannelContent.index.otherLayers')}
              </div>
              <Field
                shouldUpdate={(p, c) => {
                  return get(p, `${layers}`) !== get(c, `${layers}`);
                }}>
                {(
                  props,
                  meta,
                  { getFieldValue, setFields, setFieldsValue },
                ) => {
                  const data = getFieldValue(layers) || [];
                  const disabledAdd = data.length >= 5 || disabled;
                  return (
                    <Button
                      disabled={disabledAdd}
                      buttonText={`+ ${getI18n(
                        'salesChannelContent.index.addLayer',
                      )}`}
                      onClick={handleOnAdd}
                      avoidAlert
                      className={css.btnClassName}
                    />
                  );
                }}
              </Field>
              <DragNDrop
                disableAllDrags={disabled}
                droppableId={'SalesChannelContentListImageDraggableLayer'}
                list={value || []}
                childGenerator={renderChild}
                onChange={handleOnOrderOnChange}
              />
            </Section>
          </React.Fragment>
        );
      }}
    </Field>
  );
};
export default Layers;

const LayerHeader = (props) => {
  const { extra, disabled, ..._p } = props;

  const {
    //editForm,
    layerForm,
    selectedLayer,
    breakpoint,
    layer,
  } = extra;
  const draggableId = get(layer, 'draggableId');
  const isSelected = draggableId === selectedLayer;

  //const editData = Form.useWatch([], editForm);
  const layerData = Form.useWatch([], layerForm);
  const checkHasError = () => {
    if (isSelected) {
      const data = layerData;
      const res = validateLayerType(data, { breakpoint, disabled });
      return get(res, 'hasError');
    } else {
      const data = layer;
      const res = validateLayerType(data, { breakpoint });
      return get(res, 'hasError');
    }
  };

  return (
    <GeneralCollapseHeader
      {..._p}
      err={checkHasError()}
      arrowClassName={css.arrowClassName}
      hasArrow
      containerStyle={isSelected ? { backgroundColor: '#ccefd4' } : {}}
      // containerProps={
      //   //   {
      //   //   ...(isSelected
      //   //     ? {
      //   //         style: { backgroundColor: '#ccefd4' },
      //   //       }
      //   //     : {}),
      //   // }
      // }
    />
  );
};

const LayerName = (props) => {
  const { value, onChange, disabled } = props;
  const [selected, setSelected] = React.useState(false);
  return (
    <div
      style={{ width: '100%', minWidth: 60, minHeight: 20 }}
      onClick={() => {
        if (disabled) return;
        setSelected(true);
      }}>
      {selected ? (
        <Input
          maxLength={100}
          size='large'
          onBlur={(e) => {
            onChange(e.target.value);
            setSelected(false);
            //console.log('e', e.target.value);
          }}
          value={value}
          onChange={onChange}
        />
      ) : (
        value
      )}
    </div>
  );
};
